/**
 * Entry point for the LO Prospect Pipeline section. Route-level access is
 * controlled by `view_recruiting`; this component resolves the current org/user.
 */
import React from 'react';
import { useAuth } from '@/contexts/useAuth';
import { LoProspectPipeline } from './LoProspectPipeline';

export function LoProspectsPage() {
  const { user } = useAuth();
  const userId = (user as { id?: string } | null)?.id;
  const organizationId = (user as { organization_id?: string } | null)?.organization_id;

  if (!organizationId || !userId) {
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">
        Unable to resolve your organization.
      </div>
    );
  }

  return <LoProspectPipeline organizationId={organizationId} userId={userId} />;
}
